<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm8 md4>
      <v-card max-width="380" class="mx-auto">
        <v-layout align-center justify-center column class="pt-6">
          <v-img
            :src="require('@/assets/images/afterlife_logo_main.svg')"
            width="250px"
            height="180px"
            style="background-size: contain"
          ></v-img>
          <div class="subtitle-1">Sign into your account</div>
        </v-layout>
        <div class="pa-6">
          <v-tabs v-model="tab" class="no-tab-bar">
            <v-tabs-items v-model="tab">
              <v-tab-item value="username-tab">
                <v-form
                  ref="form"
                  @submit.prevent="handleLogin"
                  style="margin: 8px 0"
                >
                  <v-text-field
                    autofocus
                    outlined
                    clearable
                    required
                    v-model="form.username"
                    label="Email or phone number"
                    :error-messages="
                      form.$getError('username') || form.$getError('email')
                    "
                  ></v-text-field>
                  <v-text-field
                    autofocus
                    outlined
                    required
                    type="password"
                    label="Password"
                    v-model="form.password"
                    :error-messages="form.$getError('password')"
                  ></v-text-field>
                  <v-btn
                    block
                    large
                    color="primary"
                    type="submit"
                    :loading="form.$busy"
                    >Submit</v-btn
                  >
                  <div class="mt-4" v-if="showCreateAccount">
                    <v-btn text color="primary" block>Create new account</v-btn>
                  </div>
                </v-form>
              </v-tab-item>
              <v-tab-item value="otp-tab">
                <div class="d-flex justify-center mb-2 bg-surface-variant">
                  <v-chip
                    class="ma-2"
                    :closable="true"
                    @click="tab = 'username-tab'"
                  >
                    {{ form.username }}
                  </v-chip>
                </div>
                <v-form ref="form" @submit.prevent="handleSubmit">
                  <v-text-field
                    autofocus
                    outlined
                    required
                    type="text"
                    label="One Time Passwod"
                    v-model="form.otp"
                    :error-messages="form.$getError('otp')"
                  ></v-text-field>
                  <v-btn
                    block
                    large
                    color="primary"
                    type="submit"
                    :loading="form.$busy"
                    >Sign in</v-btn
                  >
                </v-form>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Form from '@/utils/form'

export default {
  name: 'LoginPage',
  data() {
    return {
      showForgotPassword: false,
      showCreateAccount: false,
      tab: 'username-tab',
      form: new Form({
        username: null,
        password: null,
        otp: null,
      }),
    }
  },

  methods: {
    checkUsername() {
      this.form.$clearErrors()
      this.form.$busy = true
      this.$api
        .post('auth/check-username', { username: this.form.username })
        .then(({ data }) => {
          this.form.$busy = false
          this.showPasswordTab()
        })
        .catch((err) => {
          this.form.$busy = false
          if (err.response.status === 404) {
            this.form.$setErrors({ username: err.response.data.message })
          } else if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
    },

    handleSubmit() {
      this.form.$clearErrors()
      this.form.$busy = true
      this.$api
        .post('/auth/login', {
          email: this.form.username,
          password: this.form.password,
          otp: this.form.otp,
        })
        .then(({ data }) => {
          this.form.$busy = false
          this.$store.commit('auth/setToken', data.token)
          this.$router.replace({ name: 'home' })
        })
        .catch((err) => {
          this.form.$busy = false
          if (err.response.status === 401) {
            this.form.$setErrors({ password: err.response.data.message })
          } else if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
    },
    handleLogin() {
      this.form.$clearErrors()
      this.form.$busy = true
      this.$api
        .post('/auth/check', {
          email: this.form.username,
          password: this.form.password,
        })
        .then(({ data }) => {
          this.form.$busy = false
          this.tab = 'otp-tab'
        })
        .catch((err) => {
          this.form.$busy = false
          if (err.response.status === 401) {
            this.form.$setErrors({ password: err.response.data.message })
          } else if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
    },

    notYou() {
      this.clearForm()
    },

    showUsernameTab() {
      this.tab = 'username-tab'
    },

    showPasswordTab() {
      this.tab = 'password-tab'
    },

    clearForm() {
      this.form.$reset()
      this.showUsernameTab()
    },
  },
  watch: {
    'form.username'() {
      this.form.$clearError('username')
    },
    'form.password'() {
      this.form.$clearError('password')
    },
  },
}
</script>
